import React, { useState } from 'react';
import { FunctionComponent } from 'react';
import { userSelectors } from '../../../../app/resource/user/user.selectors';
import { IUser } from '../../../../app/resource/user/user.types';
import { useSelectWithParams } from '../../../../utils/selector.utils';
import { IUserFilterProps } from './types';

export const UserFilter: FunctionComponent<IUserFilterProps> = ({ userIds, setFilterId }) => {
  const [toggleUsers, setToggleUsers] = useState(false);
  const [selectedId, setSelectedId] = useState('');
  const [title, setTitle] = useState('Filter by User');
  const users = useSelectWithParams(userSelectors.selectResourcesById, userIds) as IUser[];
  return (
    <div className="field-container custom-select smaller-select with-checkbox mb-0 w280">
      <input type="hidden" />
      <span className={`select-field ${toggleUsers ? 'active' : ''}`} onClick={() => setToggleUsers(!toggleUsers)}>
        <span className="select-value">{title}</span> <i className="icon-down-dir" />
      </span>
      <div className="select-dropdown" style={{ boxSizing: 'border-box', display: toggleUsers ? 'block' : 'none' }}>
        <div
          className={`select-item ${selectedId === '' ? 'selected' : ''}`}
          data-val="All Users"
          onClick={() => {
            setSelectedId('');
            setToggleUsers(false);
            setTitle('All Users');
            setFilterId('');
          }}
        >
          All Users
        </div>
        {users.map((user) => (
          <div
            key={user.id}
            className={`select-item ${selectedId === user.id ? 'selected' : ''}`}
            data-val={`${user.firstName} ${user.lastName}`}
            onClick={() => {
              setSelectedId(user.id);
              setToggleUsers(false);
              setTitle(`${user.firstName} ${user.lastName}`);
              setFilterId(user.id);
            }}
          >
            {`${user.firstName} ${user.lastName}`}
          </div>
        ))}
      </div>
    </div>
  );
};
